import type { EpisodeCategory } from '../../common/enums/episodeCategory';
import type { IServicesByServiceGroupForEpisodeCategory } from '../../common/interfaces/servicesByServiceGroupForEpisodeCategory';
import type { IServiceGroupMembership } from '../interfaces/serviceGroupMembership';

export function groupServiceGroupMembershipsByEpisodeCategory(serviceGroupMemberships: IServiceGroupMembership[]) {
    const groupedByEpisodeCategory: { [key: string]: IServicesByServiceGroupForEpisodeCategory } = {};

    for (const serviceGroupMembership of serviceGroupMemberships) {
        if (groupedByEpisodeCategory[serviceGroupMembership.service.episodeCategory.id]) {
            const serviceGroup = groupedByEpisodeCategory[
                serviceGroupMembership.service.episodeCategory.id
            ].serviceGroups.find(
                (serviceGroupsItem) => serviceGroupsItem.id === serviceGroupMembership.serviceGroup.id
            );

            if (serviceGroup?.services) {
                serviceGroup.services.push(createServiceItem(serviceGroupMembership));
            } else {
                groupedByEpisodeCategory[serviceGroupMembership.service.episodeCategory.id].serviceGroups.push({
                    id: serviceGroupMembership.serviceGroup.id,
                    name: serviceGroupMembership.serviceGroup.name,
                    services: [createServiceItem(serviceGroupMembership)],
                });
            }
        } else {
            groupedByEpisodeCategory[serviceGroupMembership.service.episodeCategory.id] = {
                episodeCategory: {
                    id: serviceGroupMembership.service.episodeCategory.id,
                    name: serviceGroupMembership.service.episodeCategory.name as EpisodeCategory,
                },
                serviceGroups: [
                    {
                        ...serviceGroupMembership.serviceGroup,
                        services: [createServiceItem(serviceGroupMembership)],
                    },
                ],
            };
        }
    }

    return Object.values(groupedByEpisodeCategory);
}

function createServiceItem(item: IServiceGroupMembership) {
    return {
        code: item.service.code,
        id: item.service.id,
        name: item.service.name,
        serviceType: item.service.serviceType,
    };
}
